import {Injectable} from '@angular/core';
import {VerityPriceModel} from '../models/verity-price-model';
import {AuthService} from './auth.service';
import {Observable, Subject} from 'rxjs';
import {VeritiyPricesTableRowModel} from '../../prices-view/models/verity-prices-table-row-model';

@Injectable({
    providedIn: 'root'
})
export class TableDetailsService {

    private _pagerSize = 5;
    public sortData: Array<VerityPriceModel>;

    constructor(private authService: AuthService) {

    }

    get pagerSize() {
        return this._pagerSize;
    }

    set pagerSize(value) {
        this._pagerSize = value;
    }

    public addSkuDetails(tableColumns: Array<VeritiyPricesTableRowModel>): Observable<any> {
        const result = new Subject();

        this.authService.isTestingUser().subscribe(isTestUser => {
            if (isTestUser) {
                let veritiyPricesTableRowModel = tableColumns.find(row => row.key === 'SKU_id');
                if (!veritiyPricesTableRowModel) {
                    tableColumns.push(new VeritiyPricesTableRowModel(30, 100, 'SKU_id', 'SKU_id', true, 'left'));
                }

                veritiyPricesTableRowModel = tableColumns.find(row => row.key === 'Loc_Product_cd');
                if (!veritiyPricesTableRowModel) {
                    tableColumns.push(new VeritiyPricesTableRowModel(31, 100, 'Loc_Product_cd', 'Loc_Product_cd', true, 'left'));
                }
            }
            result.next();
        });

        return result.asObservable();
    }

}

